// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../config/styles';

const styles = theme => ({
  root: {
    margin: '15px 0',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  buttonStyle: {
    marginBottom: 18,
  },
  inputsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down(400)]: {
      flexDirection: 'column',
    },
  },
  submitButtonStyle: {
    margin: '15px auto',
  },
  successText: {
    color: GlobalStyles.color.COLOR_GREEN,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
  },
  rejectedColor: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  popup: {
    position: 'absolute',
    maxWidth: 520,
    left: -70,
    width: 520,
    maxHeight: 250,
    overflowX: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    color: GlobalStyles.color.COLOR_GREY,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    top: 75,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
    borderRadius: 10,
    [theme.breakpoints.down(550)]: {
      width: 400,
      left: -10,
      top: 125,
    },
    [theme.breakpoints.down(430)]: {
      width: 320,
    },
  },
  searchResult: {
    borderBottom: '1px solid black',
    padding: '5px 10px',
    maxHeight: 35,
    cursor: 'pointer',
  },
  popupLabel: {
    margin: '0 10px',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  }
});

export default styles;
